export enum OrganizationEnum {
  VIKINGSE = 'VIKINGSE',
  VIKINGNO = 'VIKINGNO',
  VIKINGFI = 'VIKINGFI',
  VIKINGDK = 'VIKINGDK',
  VIKINGDE = 'VIKINGDE',
  VIKINGGUARDNO = 'VIKINGGUARDNO',
  KNA = 'KNA',
  NOELBI = 'NOELBI',
}

/** Returns true if the string is a known market organization ID (e.g. from route params). Use to avoid treating route segments like "dashboard" as organizationId. */
export function isKnownMarketOrganizationId(id: string | undefined): id is OrganizationEnum {
  if (!id) return false;
  return Object.values(OrganizationEnum).includes(id as OrganizationEnum);
}
